import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IPkHierarchy } from '../models/models'

export class ListPkHierarchyApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/listHierarchy',
      requesterInfo,
    })
  }

  public async listHierarchy(): Promise<IPkHierarchy[]> {
    return await this.getAsync<IPkHierarchy[]>()
  }
}
